"use client";

import { useState } from "react";
import { BsArrowLeft, BsArrowRight } from "react-icons/bs";
import DeferredImage from "./DeferredImage";

/**
 * Card gallery that only mounts the current photo.
 * Avoids TinySlider dumping every slide into the DOM (and Next preloading them).
 */
const CardImageSlider = ({
  images,
  alt = "",
  className,
  imgStyle,
  onError,
  aspectRatio = "4 / 3",
}) => {
  const [index, setIndex] = useState(0);
  const list = Array.isArray(images) ? images.filter(Boolean) : [];

  if (list.length === 0) return null;

  const current = list[index % list.length];
  const canNav = list.length > 1;

  const go = (delta) => {
    setIndex((currentIndex) => (currentIndex + delta + list.length) % list.length);
  };

  return (
    <div
      className={className}
      style={{
        position: "relative",
        aspectRatio,
        overflow: "hidden",
        width: "100%",
      }}
    >
      <DeferredImage
        src={current}
        alt={alt}
        className="card-image-slider__img"
        style={imgStyle}
        onError={onError}
      />
      {canNav ? (
        <div className="card-image-slider__controls">
          <button
            type="button"
            className="card-image-slider__btn"
            aria-label="Previous image"
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              go(-1);
            }}
          >
            <BsArrowLeft size={16} />
          </button>
          <button
            type="button"
            className="card-image-slider__btn"
            aria-label="Next image"
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              go(1);
            }}
          >
            <BsArrowRight size={16} />
          </button>
        </div>
      ) : null}
    </div>
  );
};

export default CardImageSlider;
